import { render, staticRenderFns } from "./OnBoardingPage.vue?vue&type=template&id=3a330586&scoped=true"
import script from "./OnBoardingPage.vue?vue&type=script&lang=js"
export * from "./OnBoardingPage.vue?vue&type=script&lang=js"
import style0 from "./OnBoardingPage.vue?vue&type=style&index=0&id=3a330586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a330586",
  null
  
)

export default component.exports